import React from 'react';

import PropTypes from 'prop-types';

const CardCloseButton = (props) => {
   return (
      <div
         className='position-absolute'
         style={{
            'top': 4,
            'right': 10,
         }}>
         <button
            type='button'
            onClick={props.handleClick}
            className='close btn'
            aria-label='close'>
            <span aria-hidden='true'>&times;</span>
         </button>
      </div>
   );
};

CardCloseButton.propTypes = {
   handleClick: PropTypes.func.isRequired,
};

export default CardCloseButton;
